import React from "react";
import { Autocomplete, Stack, TextField } from "@mui/material";
import type { Question } from "../../../../../../types/rubric";
import type { OperandDto } from "../../../../../../types/resolver";
import type { OperandTypeComponentProps } from "./types";

export interface AnswerOperandProps extends OperandTypeComponentProps {
    questionSearch: string;
    onQuestionSearchChange: (value: string) => void;
    questionOptions: Question[];
    questionLoading: boolean;
    selectedQuestion: Question | null;
    onQuestionChange: (question: Question | null) => void;
    getQuestionLabel: (q: Question) => string;
}

export const AnswerOperand: React.FC<AnswerOperandProps> = ({
    value,
    onChange,
    questionSearch,
    onQuestionSearchChange,
    questionOptions,
    questionLoading,
    selectedQuestion,
    onQuestionChange,
    getQuestionLabel,
}) => (
    <Autocomplete<Question>
        size="small"
        fullWidth
        loading={questionLoading}
        inputValue={selectedQuestion ? getQuestionLabel(selectedQuestion) : questionSearch}
        onInputChange={(_, val, reason) => {
            if (reason === "input") onQuestionSearchChange(val);
            if (reason === "clear") onQuestionSearchChange("");
        }}
        value={selectedQuestion}
        onChange={(_, q) => onQuestionChange(q)}
        options={questionOptions}
        getOptionLabel={getQuestionLabel}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        renderInput={(params) => (
            <TextField {...params} label="Question (answer set)" placeholder="Search by name or ID" />
        )}
    />
);
